import { primary } from 'presentations/views/styles/color';
import {
  fontSize,
  fontWeight,
  isMediaMax,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import Button from 'presentations/views/components/atoms/Button';
import Icon from 'presentations/views/components/atoms/Icon';

interface Props {
  imageUrl: string;
  imageWidth?: number;
  imageHeight?: number;
  icon?: string;
  title: string;
  description: string;
  link?: string;
  linkTitle?: string;
  direction?: string;
}

export default function Component(props: Props) {
  const direction = props.direction || 'normal';
  const isMobile = isMediaMax('tablet');
  return (
    <Content direction={direction}>
      <MainContent direction={direction}>
        <TitleContainer>
          {props.icon && (
            <IconContainer>
              <TitleIcon
                name={props.icon}
                size={fontSize(isMobile ? 20 : 28)}
              />
            </IconContainer>
          )}
          <Title>{props.title}</Title>
        </TitleContainer>
        <Description>{props.description}</Description>
        {!isMobile && props.link && (
          <LinkButton color="primary" size="large">
            {props.linkTitle}
          </LinkButton>
        )}
      </MainContent>
      <MainIcon
        src={props.imageUrl}
        width={props.imageWidth}
        height={props.imageHeight}
        alt={props.title}
        dpr={2}
      />
      {isMobile && props.link && (
        <LinkButton color="primary" size="large">
          {props.linkTitle}
        </LinkButton>
      )}
    </Content>
  );
}
const Content = styled.div<{ direction: string }>`
  display: flex;
  flex-direction: ${(props) => {
    if (props.direction === 'odd') return 'row-reverse';
    return 'row';
  }};
  ${mediaMax.tablet} {
    display: block;
    text-align: center;
  }
`;
const MainIcon = styled(Image)`
  /* box-shadow: 0px 10px 30px rgba(102, 102, 102, 0.15); */
  max-width: 100%;
  height: auto;
  ${mediaMax.tablet} {
    margin: ${spacing(16)} 0 ${spacing(8)};
  }
`;
const MainContent = styled.div<{ direction: string }>`
  margin-right: ${(props) => {
    if (props.direction === 'odd') return 0;
    return spacing(40);
  }};
  margin-left: ${(props) => {
    if (props.direction === 'odd') return spacing(40);
    return 0;
  }};

  ${mediaMax.tablet} {
    margin-left: 0;
    margin-right: 0;
    text-align: center;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  margin-bottom: ${spacing(16)};
`;
const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(24)};
  ${mediaMax.tablet} {
    text-align: left;
    font-size: ${fontSize(18)};
  }
`;
const TitleIcon = styled(Icon)`
  color: ${primary};
`;
const Description = styled.div`
  white-space: pre-wrap;
  ${mediaMax.tablet} {
    text-align: left;
  }
`;
const LinkButton = styled(Button)`
  margin-top: ${spacing(24)};
  ${mediaMax.tablet} {
    margin-top: 0;
  }
`;

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
  margin-right: ${spacing(8)};
  ${mediaMax.tablet} {
    width: 20px;
    height: 20px;
  }
`;
